// SettingsNavigationBar.tsx
import React, { useState, MouseEvent } from "react";
import { IconButton, Menu, MenuItem, Tooltip, Typography,Divider } from "@mui/material";
import AssessmentIcon from '@mui/icons-material/Assessment';
import { useNavigation } from "../Context/Contexts";
import { useTranslation } from "react-i18next";

const ReportNavigationBar: React.FC = () => {
    const { navigate } = useNavigation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const { t } = useTranslation();

    const handleClick = (event: MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleNavigate = (to: string) => {
        navigate({ path: to });
        handleClose();
    };
    const reportSections = [
        {
            title: t("common.sales"),
            items: [
                { title: t("common.items"), to: "/report/sales/item" },
                { title: t("common.variant"), to: "/report/sales/variant" },


            ],
        },
        {
            title: t("common.inventory"),
            items: [
                { title: t("common.value"), to: "/report/inventory/value" },
                { title: t("common.qty"), to: "/report/inventory/qty" }
            ]
        },
        {
            title: t("common.finance"),
            items: [
                { title: t("common.summary"), to: "/report/finance/accountsummary" },
                { title: t("common.account"), to: "/report/finance/accountdimension" }
            ]
        }
    ];


    return (
        <>
            <Tooltip title={t("common.reports")}>
            <IconButton onClick={handleClick} color="secondary">
                    <AssessmentIcon />
                </IconButton>
            </Tooltip>
     

            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>

                {reportSections.map((section, index) => (
                    <React.Fragment key={section.title}>
                        {index > 0 && <Divider />} {/* Divider between sections */}
                        <Typography variant="caption" sx={{ px: 2, py: 1, color: "gray" }}>
                            {section.title}
                        </Typography>
                        {section.items.map(item => (
                            <MenuItem key={item.title} href={item.to} component="a"
                                sx={{
                                    fontSize: 14,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                }}

                            >
                                {item.title}
                            </MenuItem>
                        ))}
                    </React.Fragment>
                ))}
            </Menu>
        </>
    );
};

export default ReportNavigationBar;
